var $00434664ff5fbc5a$exports = {};
$00434664ff5fbc5a$exports = {
    "help": `Ajuda`,
    "info": `Informa\xe7\xf5es`
};


export {$00434664ff5fbc5a$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
